import { __awaiter } from "tslib";
import { PublicVideo } from '@wix/wix-vod-api-site-based/dist/src/public/services/video/video';
import { toError } from '../../parsers/to-error';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
export class PublicVideoApiService {
    constructor(httpClient, baseUrl) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
        this.getVideoUrls = (videoId, channelId, instance, baseUrl) => {
            return this.siteBasedPublicVideoService
                .getVideoUrls(videoId, channelId, instance)
                .then((response) => response.data)
                .catch(toError);
        };
        this.getDownloadUrl = (videoId, channelId, instance) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            return PublicVideo.getDownloadUrl((_a = this.baseUrl) !== null && _a !== void 0 ? _a : PRODUCTION_HOSTS.catalog, videoId, channelId, instance);
        });
        this.siteBasedPublicVideoService = new PublicVideo(httpClient, baseUrl);
    }
}
//# sourceMappingURL=video.js.map